// extracted by mini-css-extract-plugin
export var downArrow = "_ia-0";
export var infoTooltipIcon = "_ia-3";
export var label = "_ia-1";
export var optionCard = "_ia-4";
export var upArrow = "_ia-2";